__turbopack_context__.v({
  "btnLink": "styles-module-scss-module__y7tsmW__btnLink",
  "content": "styles-module-scss-module__y7tsmW__content",
  "root": "styles-module-scss-module__y7tsmW__root",
  "title": "styles-module-scss-module__y7tsmW__title",
});
